import { css } from '@emotion/core';
import { MediaQueries } from '../../../../styles/Grid';
import { typography, fontWeights } from '../../../../styles/typography';
import { colorsPalette } from '../../../../styles/colors';

export const bottom_links = css({
  position: 'fixed',
  bottom: '30px',
  paddingLeft: '12px',

  [MediaQueries.md]: {
    paddingLeft: '12px',
    width: '382px',
  },
  [MediaQueries.sm]: {
    paddingLeft: '32px',
    width: '100%',
  },

  ul: {
    display: 'flex',
    [MediaQueries.md]: {
      width: '100%',
      justifyContent: 'space-between',
    },

    li: {
      display: 'flex',
      marginRight: '32px',
      fontSize: '12px',
      lineHeight: '20px',
      fontWeight: '500',
      letterSpacing: '0.800000011920929px',
      textAlign: 'left',
      textTransform: 'uppercase',

      a: { color: '#393939', textDecoration: 'none' },
    },

    'li:last-child': {
      marginRight: '0',
    },
  },
});

export const itemsContainerCss = css({
  marginTop: 10,
  width: '100% !important',
  maxHeight: 'calc(100vh - 13rem)',
  overflowY: 'auto',
  [MediaQueries.sm]: {
    paddingLeft: '30px',
  },

  '::-webkit-scrollbar': { width: '8px' },
  '::-webkit-scrollbar-track': { background: 'transparent' },
  '::-webkit-scrollbar-thumb': { background: '#f4f3f0', borderRadius: '16px' },
  '::-webkit-scrollbar-thumb:hover': { background: '#f4f3f0' },

  '.subtabs': {
    img: { marginRight: '15px', position: 'relative', top: '2px' },
  },

  a: { color: '#393939', textDecoration: 'none' },

  h2: {
    marginBottom: '32px',
    fontWeight: '500',
    span: {
      fontSize: '22px',
      lineHeight: '32px',
      letterSpacing: '-0.004em',
      textAlign: 'left',
    },
  },

  '.accordion__heading:hover': {
    h2: {
      span: {
        borderBottom: '#E52500 solid 1px',
      },
    },
  },

  '.accordion__heading': {
    outline: '0',
    cursor: 'pointer',
    marginBottom: '20px',

    '[aria-expanded="true"]': {
      outline: '0',
      h2: {
        span: {
          borderBottom: '#E52500 solid 1px',
        },
      },
    },

    '.accordion__button': {
      outline: '0',
    },
  },

  '.accordion__panel': {
    h3: {
      fontSize: '18px',
      lineHeight: '32px',
      letterSpacing: '0px',
      textAlign: 'left',
      marginBottom: '5px',
      fontWeight: '500',
    },

    '.subtabs': {
      a: { fontSize: '18px' },
    },

    button: {
      background: 'transparent',
      border: '0',
      paddingLeft: '0',
      cursor: 'pointer',
    },

    '.sales-number': {
      marginTop: '8px',
      display: 'grid',
      marginBottom: '16px',

      'span:first-child': {
        fontSize: '14px',
        lineHeight: '24px',
        fontWeight: '500',
        letterSpacing: '0px',
        textAlign: 'left',
        color: '#008385',
      },

      'span:last-child': {
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '32px',
        letterSpacing: '0px',
        textAlign: 'left',
      },
    },
    li: {
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '32px',
      marginBottom: '24px',
      letterSpacing: '0px',
      textAlign: 'left',

      ' .is-active': {
        fontSize: '22px',
        lineHeight: '32px',
        fontWeight: '500',
        letterSpacing: '-0.004em',
        textAlign: 'left',
      },

      img: {
        marginRight: '15px',
        position: 'relative',
        top: '2px',
      },
    },
  },

  '.accordion__item': {
    h2: {
      fontSize: '22px',
      lineHeight: '32px',
      letterSpacing: '-0.004em',
      textAlign: 'left',
      marginTop: '0px',
      fontWeight: '500',
      marginBottom: '16px',
    },
  },

  [MediaQueries.md]: {},
  [MediaQueries.lgAndUp]: {
    marginTop: 0,
  },
});

export const itemTextCss = css(typography.effra40, {
  color: 'inherit',
  pointerEvents: 'none',
  fontWeight: fontWeights.light,
  position: 'relative',
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: -2,
    left: 0,
    width: '100%',
    height: 1,
    borderBottom: `1px solid ${colorsPalette.grey90}`,
  },
});

export const activeTextCss = css({
  '&:after': {
    borderBottom: `1px solid ${colorsPalette.grey50}`,
  },
});

export const activeItemCss = css({
  color: colorsPalette.white,
});

export const itemCss = css({
  marginBottom: 16,
  [MediaQueries.md]: {
    marginBottom: 29,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 27,
  },
});

export const buttonCss = css({
  cursor: 'pointer',
  color: colorsPalette.grey50,
  '&:hover': {
    color: colorsPalette.white,
  },
});

export const titleCss = css(typography.effra40, {
  color: colorsPalette.grey40,
  fontWeight: fontWeights.light,
  [MediaQueries.lg]: {
    marginBottom: 24,
  },
  [MediaQueries.xl]: {
    marginBottom: 32,
  },
});

export const descriptionCss = css(typography.effra18, {
  color: colorsPalette.grey20,
  [MediaQueries.lg]: {
    marginBottom: 32,
  },
  [MediaQueries.xl]: {
    marginBottom: 40,
  },
});

export const bottomLinksCss = css({
  alignItems: 'flex-end',
  bottom: 57,
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'column',
  position: 'absolute',
  right: 0,

  button: {
    borderBottom: '1px solid #656566',
    paddingLeft: '0',
  },

  a: {
    borderBottom: '1px solid #656566',
  },

  h4: {
    marginBottom: '8px',
  },
  [MediaQueries.md]: {
    bottom: 65,
  },
  [MediaQueries.lg]: {
    textAlign: 'right',
  },
});

export const linkStyleCss = css(typography.effra16, {
  border: 'none',
  backgroundColor: 'transparent',
  paddingRight: '0px',
  cursor: 'pointer',
  marginBottom: '10px',
  borderBottom: `1px solid ${colorsPalette.transparent}`,
  color: colorsPalette.white,
  textAlign: 'end',
  textDecoration: 'none',
  '&:hover': {
    borderColor: colorsPalette.grey90,
  },
});

export const bottomRightLink1Css = css({
  marginBottom: 8,
});

export const verticalLineCss = css({
  position: 'absolute',
  width: 1,
  height: '100%',
  top: 0,
  left: '36%',
  borderLeft: `1px solid ${colorsPalette.white}`,
  opacity: 0.05,
});
